<main class="container layout-39">
  @if (!embedded) {
  <div id="containerLeftMenu" style="margin-right: 15px">
    <left-menu />
  </div>
  }

  <section id="column2">
    <div class="row">
      <div class="col col-12">
        @if (!embedded) {
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h1 class="mb-0 text-center w-100">POD's List</h1>
        </div>
        }

        @if (pageLoading) {
<app-pods-list-skeleton></app-pods-list-skeleton>
}

        @if (!pageLoading) {
<app-spinner [isLoading]="isLoading" diameter="50" loadingText="Applying POD changes..."></app-spinner>

        @if (error) {
<div class="alert alert-danger">
          <mat-icon>error_outline</mat-icon>
          {{ error }}
        </div>
}

<div class="w-100">
          <div class="card mb-3">
            <div class="card-body">
              <h4 class="card-title mb-3">Add POD</h4>
              <div class="row">
                <div class="col-md-6 mb-2">
                  <label class="form-label">Name</label>
                  <input class="form-control" [(ngModel)]="createName" [disabled]="isLoading" placeholder="POD name" />
                </div>
                <div class="col-md-3 mb-2">
                  <label class="form-label">Visible</label>
                  <div class="custom-control custom-checkbox mt-2">
                    <input type="checkbox" class="custom-control-input" id="create-visible" [(ngModel)]="createIsVisible" [disabled]="isLoading" />
                    <label class="custom-control-label" for="create-visible">Visible</label>
                  </div>
                </div>
                <div class="col-md-3 mb-2 d-flex align-items-end">
                  <button class="btn btn-primary no-arrow w-100" (click)="createPod()" [disabled]="isLoading">
                    Add
                  </button>
                </div>
              </div>
            </div>
          </div>

          @if (tableLoading) {
<app-pods-list-table-skeleton></app-pods-list-table-skeleton>
}

          @if (!tableLoading) {
<div class="card">
            <div class="card-body">
              @if (pods) {
<div class="table-responsive">
                <table mat-table [dataSource]="pods" matSort class="mat-elevation-z0 w-100 pods-table">
                  <ng-container matColumnDef="podId">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
                    <td mat-cell *matCellDef="let pod">{{ pod.podId }}</td>
                  </ng-container>

                  <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                    <td mat-cell *matCellDef="let pod">
                      @if (editPodId === pod.podId) {

                        <input class="form-control" [(ngModel)]="editName" [disabled]="isLoading" />
                      
} @else {

                        {{ pod.name }}
                      
}
                      
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="isVisible">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Visible</th>
                    <td mat-cell *matCellDef="let pod">
                      @if (editPodId === pod.podId) {

                        <input type="checkbox" [(ngModel)]="editIsVisible" [disabled]="isLoading" />
                      
} @else {

                        {{ pod.isVisible ? 'Yes' : 'No' }}
                      
}
                      
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef>Actions</th>
                    <td mat-cell *matCellDef="let pod">
                      @if (editPodId === pod.podId) {

                        <div class="d-inline-flex align-items-center">
                          <button class="btn btn-sm btn-success no-arrow mr-2" (click)="saveEdit()" [disabled]="isLoading">Save</button>
                          <button class="btn btn-sm btn-secondary no-arrow" (click)="cancelEdit()" [disabled]="isLoading">Cancel</button>
                        </div>
                      
} @else {

                        <div class="d-inline-flex align-items-center">
                          <button class="btn btn-sm btn-primary no-arrow mr-2" (click)="startEdit(pod)" [disabled]="isLoading">Edit</button>
                          <button class="btn btn-sm btn-danger no-arrow" (click)="deletePod(pod.podId)" [disabled]="isLoading">Delete</button>
                        </div>
                      
}
                      
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumnsKeys"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumnsKeys"></tr>
                </table>

                <mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 50]" [showFirstLastButtons]="true"></mat-paginator>
              </div>
}
            </div>
          </div>
}
        </div>
}
      </div>
    </div>
  </section>
</main>
